export default "__VITE_ASSET__Bk57Rq6K__"